import { FC } from "react";
import EllipsesMenuNutritionDialog from "../molecules/EllipsesMenuNutritionDialog";
import { Meal } from "@/app/nutrition/meal.enum";
import { SuplementationListItem } from "../molecules/SuplementationListItem";
import { Option } from "@/app/nutrition/option.enum";

export type SuplementationListProps = {
  data: Array<any>;
  isLoading?: boolean;
  onSetSuplementation: (
    suplementation: any,
    meal: Meal,
    option: Option
  ) => void;
};

const SuplementationList: FC<SuplementationListProps> = ({
  data,
  onSetSuplementation,
}) => {
  return (
    <div className="flex flex-col flex-grow overflow-y-scroll p-4 h-0 gap-4">
        {data.map((suplementation) => (
          <SuplementationListItem
            key={suplementation.id}
            suplementation={suplementation}
            onSetSuplementation={onSetSuplementation}
          />
        ))}
    </div>
  );
};

export default SuplementationList;
